execv2.files.objects = {
    urlFileUpload: smlbpms.baseUrl + "files/upload",
    container: document.getElementById("containerFiles"),
    containerRender: document.getElementById("tblFile")!=null? document.getElementById("tblFile").getElementsByTagName("tbody")[0] : null,
    spinner: document.getElementById("containerFiles")!=null? document.getElementById("containerFiles").querySelector(".spinner") :null,
    inpDsFile: document.getElementById("inpDsFile"),
    inpUploadParameters: document.getElementById("inpUploadParameters"),
    counter: document.querySelector(".count-files"),
    btnAddFile: document.getElementById("btnAddFile"),
    fileOrder: document.getElementById("fileOrder"),
    template: '<tr class="p-2 m-2" data-id="{CodFile}" data-id-execute-task="{CodFlowExecuteTask}" id="file-{CodFile}">\
                    <td class="avatar">{Avatar}\
                        <input type="hidden" name="inpDsFileName"      id="inpDsFileName" value="{Filename};{Filepath};{ResumeSanitize};{Sign};{RequesterCanSee};{DoctypeSanitize}"/>\
                        <input type="hidden" name="inpStRequesterFile" id="inpStRequesterFile" value="{RequesterCanSee}"/>\
                    </td>\
                    <td class="message">\
                        <div><h5 class="d-inline bold">{User}</h5> <span class="small text-lowercase {ShowUserOriginal}">({UserOriginalLabel} {UserOriginal})</span></div>\
                        <div class="message-box bg-{FileColor}">\
                            <div class="row align-items-center">\
                                <div class="d-none d-md-flex text-center" style="width:40px"><img class="mr-auto ml-auto" src="{ImageIconType}"></div>\
                                <div class="col no-horizontal-scroll">\
                                    <a href="{LinkPreview}" class="bold no-horizontal-scroll" target="_blank">{Filename}</a>\
                                    <div class="no-horizontal-scroll">{Resume}</div>\
                                </div>\
                                <div class="d-none d-lg-flex col-lg-2 text-center"><span class="badge badge-light-success text-truncate {ShowDoctype}">{Doctype}</span></div>\
                            </div>\
                        </div>\
                        <div class="text-right pt-1"><span class="small">{Date}, {Hour} {TaskTitle}</span> <span class="badge badge-light">#{CodFlowExecute}</span></div>\
                        <div class="hub-sign-envelope hidden">{CodHubSignEnvelope}</div>\
                    </td>\
                    <td class="download d-none d-lg-table-cell"><a href="{LinkDownload}" class="btn btn-primary {ShowLinkDownload}"><i class="ico-download ico-inverse ico-sm"></i></a></td>\
                    <td class="lock d-none d-lg-table-cell"><i class="ico-lock ico-sm text-dark {IsLocked}"></i></td>\
                    <td class="del d-none d-lg-table-cell"><a href="javascript:void(0)" class="{ShowDelete}" onclick="execv2.files.delete(this)" ><i class=\"ico-delete ico-sm text-danger\"></i></a></td>\
                </tr>'
}

execv2.files.setup = function () {

    h.addEventListener(execv2.files.objects.btnAddFile, "click", execv2.files.openUploader);
    if (execv2.files.objects.fileOrder)
        execv2.files.objects.fileOrder.addEventListener("change", execv2.files.reorder);
}

execv2.files.openUploader = function (obj, doctype = '') {
    if (doctype != '')
        doctype = "&inpDsDocType=" + btoa(encodeURIComponent(doctype));

    smlbpms.uploadCrypt(execv2.files.objects.inpUploadParameters.value + doctype);
}

execv2.files.getPreview = function (filePath, querystring) {
    const parts = filePath.split("/").pop().split(".");
    parts.pop();
    return `${window.appvars.baseurl}/document/preview/${parts[0]}${querystring}`;
}

execv2.files.add = function (
    filename,
    filepath,
    resume,
    querystring,
    requestercansee,
    doctype
) {

    let linkPreview = execv2.files.getPreview(filepath, querystring);

    var html = execv2.files.objects.template;
    html = html.replace(/{Avatar}/gi, execv2.objects.containerActorAvatar);
    html = html.replace(/{CodFile}/gi, "");
    html = html.replace(/{CodFlowExecuteTask}/gi, 0);

    if (execv2.objects.codFlowExecute) 
        html = html.replace(/{CodFlowExecute}/gi, execv2.objects.codFlowExecute);
    else
        html = html.replace(/#{CodFlowExecute}/gi, "");

    html = html.replace(/{Date}/gi, new Date().toLocaleDateString());
    html = html.replace(/{Doctype}/gi, doctype);
    html = html.replace(/{DoctypeSanitize}/gi, execv2.util.sanitizeTextToConcat(doctype));
    html = html.replace(/{FileColor}/gi, requestercansee ? "light-primary" : "light");
    html = html.replace(/{Filename}/gi, filename);
    html = html.replace(/{Filepath}/gi, filepath);
    html = html.replace(/{Hour}/gi, new Date().toLocaleTimeString());
    html = html.replace(/{ImageIconType}/, "../attachments/icon/default.gif");
    html = html.replace(/{IsLocked}/gi, requestercansee ? "d-none" : "");
    html = html.replace(/{LinkPreview}/gi, linkPreview);
    html = html.replace(/{RequesterCanSee}/gi, requestercansee ? "S" : "N");
    html = html.replace(/{Resume}/gi, resume);
    html = html.replace(/{ResumeSanitize}/gi, execv2.util.sanitizeTextToConcat(resume));
    html = html.replace(/{Sign}/gi, "");
    html = html.replace(/{ShowUserOriginal}/gi, "d-none");
    html = html.replace(/{ShowDelete}/gi, "");
    html = html.replace(/{ShowDoctype}/gi, doctype !== "" ? "d-inline-block" : "d-none");
    html = html.replace(/{ShowLinkDownload}/gi, "d-none");
    html = html.replace(/{TaskTitle}/gi, "");
    html = html.replace(/{User}/gi, execv2.objects.hidDsActorName.value);
    html = html.replace(/{UserOriginal}/gi, "");
    html = html.replace(/{UserOriginalLabel}/gi, "");
    

    execv2.files.objects.containerRender.insertAdjacentHTML('beforeend', html);

    execv2.ui.increaseCounter(execv2.files.objects.counter);

    var el = execv2.files.objects.containerRender.lastChild;

    bsml.convertIcons(execv2.files.objects.containerfiles);

    if (execv2.objects.isTask) {

        execv2.files.spinner.show();

        let postData = {
            "cfet": execv2.objects.codFlowExecuteTask,
            "rcs": requestercansee ? "S" : "N",
            "fn": filename,
            "fp": filepath,
            "r": resume,
            "dt": doctype
        };

        let request = new XMLHttpRequest();
        request.open('POST', `${execv2.services.urlFiles}/${execv2.objects.codFlowExecuteTaskPosition}`, true);
        request.setRequestHeader("Content-Type", "application/json");

        let afToken = document.querySelector("input[name=__RequestVerificationToken]");
        if (afToken)
            request.setRequestHeader("X-SML-AntiForgeryToken", afToken.value);

        request.onload = function (data) {
            var result = h.parseJSON(data.target.response);

            if (result != null && result.success != null) {
                el.closest("tr").setAttribute("data-id", result.success.cf);
                el.closest("tr").setAttribute("id", "file-" + result.success);

            }
            execv2.files.spinner.hide();
        };

        let data = JSON.stringify(postData);
        request.send(data);

    }
}

execv2.files.delete = function (el) {

    var tr = el.closest("tr");
    var id = tr.getAttribute("data-id");

    if (execv2.objects.isTask) {

        if (id && id != "" && id != 0) {

            bsml.confirm(null, function () {

                execv2.files.spinner.show();

                h.callWebAPI(`${execv2.services.urlFiles}/${id}`, "DELETE", {}, (result) => {
                    execv2.files.objects.containerRender.removeChild(tr);
                    execv2.files.spinner.hide();
                    captureModule.capture.load();
                });
            });

        }
    } else {

        execv2.files.objects.containerRender.removeChild(tr);

    }
    captureModule.capture.load();
}

execv2.files.list = function (order, direction) {

    if (execv2.objects.isTask) {

        execv2.files.spinner.show();

        let getData = {
            "cfe": execv2.objects.codFlowExecute,
            "cfet": execv2.objects.codFlowExecuteTask,
            "or": order ? order : "dt",
            "di": direction ? direction : "a"
        }

        h.getJSON(
            `${execv2.services.urlFiles}/${execv2.objects.codFlowExecuteTaskPosition}?${(new URLSearchParams(getData).toString())}`,
            function (data) {

                if (data != null && data.success != null) {

                    h.forEach(data.success, function (i, item) {

                        let html = execv2.files.objects.template;

                        html = html.replace(/{Avatar}/gi, item.av);
                        html = html.replace(/{CodFile}/gi, item.cf);
                        html = html.replace(/{CodFlowExecuteTask}/gi, item.cfet);
                        html = html.replace(/{CodFlowExecute}/gi, item.cfe);
                        html = html.replace(/{Date}/gi, item.dt);
                        html = html.replace(/{Doctype}/gi, execv2.util.rewriteConcatToText(item.dtp));
                        html = html.replace(/{DoctypeSanitize}/gi, item.dtp);
                        html = html.replace(/{FileColor}/gi, item.req ? "light-primary" : "light");
                        html = html.replace(/{Filename}/gi, item.fn);
                        html = html.replace(/{Filepath}/gi, item.fp);
                        html = html.replace(/{Hour}/gi, item.hr);
                        html = html.replace(/{ImageIconType}/, item.ico);
                        html = html.replace(/{IsLocked}/gi, item.req ? "d-none" : "");
                        html = html.replace(/{LinkPreview}/gi, `${window.appvars.baseurl}${item.lp}`);
                        html = html.replace(/{LinkDownload}/gi, `${window.appvars.baseurl}${item.ld}`);
                        html = html.replace(/{RequesterCanSee}/gi, item.req ? "S" : "N");
                        html = html.replace(/{Resume}/gi, item.rsm);
                        html = html.replace(/{ResumeSanitize}/gi, execv2.util.sanitizeTextToConcat(item.rsm));
                        html = html.replace(/{ShowDelete}/gi, item.del ? "" : "d-none");
                        html = html.replace(/{ShowDoctype}/gi, item.dtp !== "d-inline-block" ? "" : "d-none");
                        html = html.replace(/{ShowLinkDownload}/gi, "");
                        html = html.replace(/{ShowUserOriginal}/gi, item.uon !== "" && item.uon!==null ? "" : "d-none");
                        html = html.replace(/{Sign}/gi, "");
                        html = html.replace(/{TaskTitle}/gi, item.dtt);
                        html = html.replace(/{User}/gi, item.dn);
                        html = html.replace(/{UserOriginal}/gi, item.uon);
                        html = html.replace(/{UserOriginalLabel}/gi, item.uont);
                        html = html.replace(/{CodHubSignEnvelope}/gi, item.hse);

                        execv2.files.objects.containerRender.insertAdjacentHTML('beforeend', html);
                        execv2.ui.increaseCounter(execv2.files.objects.counter);
                        bsml.convertIcons(execv2.files.objects.containerfiles);
                    });
                }

                execv2.files.spinner.hide();
            }
        );
    }
}

execv2.files.reorder = function (event) {
    let item = event.target.options[event.target.selectedIndex];

    execv2.files.objects.containerRender.innerHTML = "";
    execv2.ui.resetCounter(execv2.files.objects.counter);
    execv2.files.list(item.dataset.or, item.dataset.di);
}

execv2.files.spinner = {

    show: function () {
        h.removeClass(execv2.files.objects.spinner, "d-none");
    },
    hide: function () {
        h.addClass(execv2.files.objects.spinner, "d-none");
    }
}


execv2.files.setup();
execv2.files.list();